/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { StockOrderCheckWithSkuInfoGoodsProcessVo } from './StockOrderCheckWithSkuInfoGoodsProcessVo';
import {
    StockOrderCheckWithSkuInfoGoodsProcessVoFromJSON,
    StockOrderCheckWithSkuInfoGoodsProcessVoFromJSONTyped,
    StockOrderCheckWithSkuInfoGoodsProcessVoToJSON,
    StockOrderCheckWithSkuInfoGoodsProcessVoToJSONTyped,
} from './StockOrderCheckWithSkuInfoGoodsProcessVo';

/**
 * 
 * @export
 * @interface StockOrderCheckWithSkuInfoVo
 */
export interface StockOrderCheckWithSkuInfoVo {
    /**
     * 订单ID
     * @type {number}
     * @memberof StockOrderCheckWithSkuInfoVo
     */
    orderId?: number;
    /**
     * 订单编号
     * @type {string}
     * @memberof StockOrderCheckWithSkuInfoVo
     */
    orderCode?: string;
    /**
     * 用户ID
     * @type {number}
     * @memberof StockOrderCheckWithSkuInfoVo
     */
    userId?: number;
    /**
     * 用户名
     * @type {string}
     * @memberof StockOrderCheckWithSkuInfoVo
     */
    userName?: string;
    /**
     * 用户编码
     * @type {string}
     * @memberof StockOrderCheckWithSkuInfoVo
     */
    userCode?: string;
    /**
     * 
     * @type {Array<StockOrderCheckWithSkuInfoGoodsProcessVo>}
     * @memberof StockOrderCheckWithSkuInfoVo
     */
    goodsProcessList?: Array<StockOrderCheckWithSkuInfoGoodsProcessVo>;
}

/**
 * Check if a given object implements the StockOrderCheckWithSkuInfoVo interface.
 */
export function instanceOfStockOrderCheckWithSkuInfoVo(value: object): value is StockOrderCheckWithSkuInfoVo {
    return true;
}

export function StockOrderCheckWithSkuInfoVoFromJSON(json: any): StockOrderCheckWithSkuInfoVo {
    return StockOrderCheckWithSkuInfoVoFromJSONTyped(json, false);
}

export function StockOrderCheckWithSkuInfoVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): StockOrderCheckWithSkuInfoVo {
    if (json == null) {
        return json;
    }
    return {
        
        'orderId': json['orderId'] == null ? undefined : json['orderId'],
        'orderCode': json['orderCode'] == null ? undefined : json['orderCode'],
        'userId': json['userId'] == null ? undefined : json['userId'],
        'userName': json['userName'] == null ? undefined : json['userName'],
        'userCode': json['userCode'] == null ? undefined : json['userCode'],
        'goodsProcessList': json['goodsProcessList'] == null ? undefined : ((json['goodsProcessList'] as Array<any>).map(StockOrderCheckWithSkuInfoGoodsProcessVoFromJSON)),
    };
}

export function StockOrderCheckWithSkuInfoVoToJSON(json: any): StockOrderCheckWithSkuInfoVo {
    return StockOrderCheckWithSkuInfoVoToJSONTyped(json, false);
}

export function StockOrderCheckWithSkuInfoVoToJSONTyped(value?: StockOrderCheckWithSkuInfoVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'orderId': value['orderId'],
        'orderCode': value['orderCode'],
        'userId': value['userId'],
        'userName': value['userName'],
        'userCode': value['userCode'],
        'goodsProcessList': value['goodsProcessList'] == null ? undefined : ((value['goodsProcessList'] as Array<any>).map(StockOrderCheckWithSkuInfoGoodsProcessVoToJSON)),
    };
}

